import React from "react";

import { isNonEmptyArray, defineCardBgColor, defineTagColor, defineBadgeRibbon } from "_helpers";

import { TooltipCustom as Tooltip } from "./_Tooltip";

import { Badge, Card, Col, Divider, Image, Row, Space, Tag, Typography } from "antd";

import defaultImg from "_assets/dashboard/server.png";

export const CardCustom = ({ entry }) => {
    const { val } = entry;
    const { Ribbon } = Badge;

    return (
        <Row gutter={[16,16]}>
            {
                isNonEmptyArray(val)
                &&
                    val.map((v, i) => {
                        const { activity } = v;
                        const { text, color } = defineBadgeRibbon(activity);

                        return (
                            <Col xs={24} lg={12} xl={8} key={i}>
                                {
                                    activity
                                    ?
                                        <Ribbon text={text} color={color}>
                                            <CardContent v={v} />
                                        </Ribbon>
                                    :
                                        <CardContent v={v} />
                                }
                            </Col>
                        );
                    })
            }
        </Row>
    );
}

const CardContent = ({ v }) => {
    const { title, apilog, envelope, email = {}, sms = {} } = v,
        { inbox: ein, outbox: eout } = email,
        { inbox: sin, outbox: sout } = sms;

    const { Text, Title } = Typography;

    return (
        <Card style={{ border: defineCardBgColor(v) }} styles={{ body: { padding: '10px' } }}>
            <Row>
                <Col xs={8} className="d-flex align-items-center p-2">
                    <Image src={defaultImg} preview={false} alt="Bdd image" height='100%' />
                </Col>
                <Col xs={16} className="p-2">
                    <Divider orientation="left" className="mt-0">
                        <Title level={4}>{title}</Title>
                    </Divider>
                    <Space direction="vertical" className="w-100" size={2}>
                        <Row align="middle">
                            <Col flex="70%">
                                <Text>Déversement quotidien :</Text>
                            </Col>
                            <Col flex={1}>
                                {
                                    apilog?.status
                                    ?
                                        <>
                                            {
                                                apilog.status === 'KO'
                                                ?
                                                    <Tooltip value={apilog} placement="right">
                                                        <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", defineTagColor(apilog.status)].join(" ")}>{ apilog.status }</Tag>
                                                    </Tooltip>
                                                :
                                                    <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", defineTagColor(apilog.status)].join(" ")}>{ apilog.status }</Tag>
                                            }
                                        </>
                                    :
                                        <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", defineTagColor()].join(" ")}>Désactivé</Tag>
                                }
                            </Col>
                        </Row>
                        <Row align="middle">
                            <Col flex="70%">
                                <Text>Courriers :</Text>
                            </Col>
                            <Col flex={1}>
                                {
                                    envelope?.status
                                    ?
                                        <>
                                            {
                                                envelope.status === 'KO'
                                                ?
                                                    <Tooltip value={envelope} placement="right">
                                                        <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", defineTagColor(envelope.status)].join(" ")}>{ envelope.status }</Tag>
                                                    </Tooltip>
                                                :
                                                    <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", defineTagColor(envelope.status)].join(" ")}>{ envelope.status }</Tag>
                                            }
                                        </>
                                    :
                                        <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", defineTagColor()].join(" ")}>Désactivé</Tag>
                                }
                            </Col>
                        </Row>
                        <Row align={ !(ein?.status || eout?.status) ? "stretch" : undefined } style={{ minHeight: '42px', marginTop: !(ein?.status || eout?.status) ? "2px" : 0 }}>
                            <Col flex="70%">
                                <Text>Emails :</Text>
                            </Col>
                            <Col flex={1}>
                                {
                                    (ein?.status || eout?.status)
                                    ?
                                        <Row gutter={4}>
                                            {
                                                ein?.status
                                                &&
                                                    <Col xs={12} className="d-flex flex-column align-items-center">
                                                        <Text>IN</Text>
                                                        {
                                                            ein.status === 'KO'
                                                            ?
                                                                <Tooltip value={ein} placement="bottom">
                                                                    <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", "w-100", defineTagColor(ein.status)].join(" ")}>{ ein.status }</Tag>
                                                                </Tooltip>
                                                            :
                                                                <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", "w-100", defineTagColor(ein.status)].join(" ")}>{ ein.status }</Tag>
                                                        }
                                                    </Col>
                                            }
                                            {
                                                eout?.status
                                                &&
                                                    <Col xs={12} className="d-flex flex-column align-items-center">
                                                        <Text>OUT</Text>
                                                        {
                                                            eout.status === 'KO'
                                                            ?
                                                                <Tooltip value={eout} placement="bottom">
                                                                    <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", "w-100", defineTagColor(eout.status)].join(" ")}>{ eout.status }</Tag>
                                                                </Tooltip>
                                                            :
                                                                <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", "w-100", defineTagColor(eout.status)].join(" ")}>{ eout.status }</Tag>
                                                        }
                                                    </Col>
                                            }
                                        </Row>
                                    :
                                        <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", defineTagColor()].join(" ")}>Désactivé</Tag>
                                }
                            </Col>
                        </Row>
                        <Row align={ !(sin?.status || sout?.status) ? "stretch" : undefined } style={{ minHeight: '42px', marginTop: !(sin?.status || sout?.status) ? "2px" : 0  }}>
                            <Col flex="70%">
                                <Text>Sms :</Text>
                            </Col>
                            <Col flex={1}>
                                {
                                    (sin?.status || sout?.status)
                                    ?
                                        <Row gutter={4}>
                                            {
                                                sin?.status
                                                &&
                                                    <Col xs={12} className="d-flex flex-column align-items-center">
                                                        <Text>IN</Text>
                                                        {
                                                            sin.status === 'KO'
                                                            ?
                                                                <Tooltip value={sin} placement="bottom">
                                                                    <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", "w-100", defineTagColor(sin.status)].join(" ")}>{ sin.status }</Tag>
                                                                </Tooltip>
                                                            :
                                                                <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", "w-100", defineTagColor(sin.status)].join(" ")}>{ sin.status }</Tag>
                                                        }
                                                    </Col>
                                            }
                                            {
                                                sout?.status
                                                &&
                                                    <Col xs={12} className="d-flex flex-column align-items-center">
                                                        <Text>OUT</Text>
                                                        {
                                                            sout.status === 'KO'
                                                            ?
                                                                <Tooltip value={sout} placement="bottom">
                                                                    <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", "w-100", defineTagColor(sout.status)].join(" ")}>{ sout.status }</Tag>
                                                                </Tooltip>
                                                            :
                                                                <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", "w-100", defineTagColor(sout.status)].join(" ")}>{ sout.status }</Tag>
                                                        }
                                                    </Col>
                                            }
                                        </Row>
                                    :
                                        <Tag className={["bdg", "d-flex", "align-items-center", "justify-content-center", "m-0", defineTagColor()].join(" ")}>Désactivé</Tag>
                                }
                            </Col>
                        </Row>
                    </Space>
                </Col>
            </Row>
        </Card>
    );
}